import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';

export const filtersDateRange = [
  'btw',
  'thisweek',
  'lastweek',
  'thismonth',
  'lastmonth',
  'thisyear',
];
const FiltersDateConst = {
  BTW: 'btw',
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  THIS_WEEK: 'thisweek',
  LAST_WEEK: 'lastweek',
  THIS_MONTH: 'thismonth',
  LAST_MONTH: 'lastmonth',
  THIS_YEAR: 'thisyear',
};
dayjs.extend(weekday);
export const filterDateValues = new Map([
  [
    FiltersDateConst.TODAY,
    { operator: 'eq', dateString: 'Today', value: dayjs() },
  ],
  [FiltersDateConst.BTW, { operator: 'btw', value: [dayjs(), dayjs()] }],
  [
    FiltersDateConst.YESTERDAY,
    {
      operator: 'eq',
      dateString: 'Yesterday',
      value: dayjs().subtract(1, 'd'),
    },
  ],
  [
    FiltersDateConst.THIS_WEEK,
    {
      operator: 'eq',
      dateString: 'ThisWeek',
      value: [dayjs().weekday(1), dayjs().weekday(7)],
    },
  ],
  [
    FiltersDateConst.THIS_MONTH,
    {
      operator: 'eq',
      dateString: 'ThisMonth',
      value: [dayjs().startOf('month'), dayjs().endOf('month')],
    },
  ],
  [
    FiltersDateConst.LAST_WEEK,
    {
      operator: 'eq',
      dateString: 'LastWeek',
      value: [
        dayjs().subtract(1, 'w').weekday(1),
        dayjs().subtract(1, 'w').weekday(7),
      ],
    },
  ],
  [
    FiltersDateConst.LAST_MONTH,
    {
      operator: 'eq',
      dateString: 'LastMonth',
      value: [
        dayjs().subtract(1, 'month').startOf('month'),
        dayjs().subtract(1, 'month').endOf('month'),
      ],
    },
  ],
  [
    FiltersDateConst.THIS_YEAR,
    {
      operator: 'eq',
      dateString: 'ThisYear',
      value: [dayjs().startOf('year'), dayjs().endOf('year')],
    },
  ],
]);

export const renderOptions = type => {
  let data = [];
  const operationTypeText = ['text', 'string'];
  const operationTypeNumber = ['float', 'int'];
  const operationTypeSelect = [
    'list',
    'activity',
    'calculation_types',
    'user_groups',
    'issue_priority',
    'user_roles',
    'status',
    'issue_status',
    'issue_watchers',
    'user',
    'issue',
    'project',
    'tracker',
    'confirmation',
    'confirmation_projects',
    'confirmation_status',
    'confirmation_trackers',
    'confirmation_issues',
    'confirmation_approvers',
    'confirmation_unapprovers',
    'confirmation_authors',
    'confirmation_editors',
    'parent',
  ];
  const operationTypeDate = ['spent_on', 'date'];

  const operationTypeBoolean = ['boolean', 'bool', 'activity'];

  operationTypeText.includes(type) &&
    (data = ['in', 'notin', 'startswith', 'endswith', 'null', 'all']);
  operationTypeSelect.includes(type) && (data = ['eq', 'noteq', 'null', 'all']);
  operationTypeDate.includes(type) &&
    (data = [
      'eq',
      'gte',
      'lte',
      'btw',
      'today',
      'yesterday',
      'thisweek',
      'lastweek',
      'thismonth',
      'lastmonth',
      'thisyear',
      'null',
      'all',
    ]);

  operationTypeBoolean.includes(type) && (data = ['eq', 'noteq']);
  operationTypeNumber.includes(type) &&
    (data = ['eq', 'gte', 'lte', 'btw', 'null', 'all']);
  return data;
};

export const selectFilters = (data, params) => {
  if (!data.hasOwnProperty('operation') && data.fieldType !== 'base_plan') {
    return;
  }
  const items = params.filters.selectedItems.map(item => {
    if (item.fieldId === data.fieldId) {
      return data;
    } else {
      return item;
    }
  });
  return { ...params, filters: { ...params.filters, selectedItems: items } };
};

export const formattedParamsData = (data, query = null) => {
  return Object.entries(data).reduce((acc, [key, value]) => {
    if (value.type === 'list') {
      const object = value;
      if (value.items.filter(item => item.isChecked).length > 0) {
        object.selectedItems = value.items
          .filter(item => item.isChecked)
          .map(item => {
            let selectedItem = item;
            if (item.predefined) {
              return {
                ...selectedItem,
                operation: item.predefined.type.toLowerCase(),
                values: filterDateValues.get(item.predefined.type.toLowerCase())
                  .value,
              };
            }
            if (item.min && item.max) {
              if (item.fieldType === 'date') {
                return {
                  ...selectedItem,
                  values: [dayjs(item.min), dayjs(item.max)],
                };
              } else {
                return {
                  ...selectedItem,
                  values: [item.min, item.max],
                };
              }
            }

            if (item.values) {
              selectedItem.values = item.values;
              item.fieldType === 'date' &&
                (selectedItem.values = dayjs(item.values));
              if (Array.isArray(item.values) && item.values.length > 0) {
                if (typeof item.values[0] === 'object') {
                  if (item.values.filter(item => item.isChecked).length > 0) {
                    selectedItem.values = item.values
                      .filter(item => item.isChecked)
                      .map(item => item.valueId);
                  } else {
                    delete selectedItem.values;
                  }
                }
                ['null', 'all'].includes(item.operation) &&
                  (selectedItem.values = item.operation);
              }
              return selectedItem;
            } else {
              delete selectedItem.values;
              return selectedItem;
            }
          });
        //if (key === 'filters' && object.selectedItems.filter(item => !item.values && !item.predefined).length > 0) {
        //  delete object.selectedItems;
        //}
        !value.multiple && (object.selectedItems = object.selectedItems[0]);
      }
      //if (!value.multiple) {
      //  const selectedItem = value.items.find(item => item.isChecked);
      //  selectedItem !== undefined && (object.selectedItems = selectedItem);
      //}
      acc[key] = object;
      //return {...acc, {}};
    }
    if (value.type === 'columns') {
      acc[key] = {
        ...value,
        selectedItems: {
          availableFields: value.items.filter(item => !item.isChecked),
          selectedFields: value.items
            .filter(item => item.isChecked)
            .sort((a, b) => a.position - b.position),
        },
      };
    }
    if (value.type === 'checkbox') {
      const object = { ...value };
      object.selectedItems = value.items.toString();
      acc[key] = object;
    }
    return acc;
  }, {});
};

export const formatFilters = params => {
  const data = {};
  function formatValue(data) {
    return data.map(item => {
      return { ...item, fieldId: item.valueId, fieldName: item.valueName };
    });
  }
  params.groups &&
    (data.groups = { items: params.groups, type: 'list', multiple: false });
  params.filters &&
    (data.filters = { items: params.filters, type: 'list', multiple: true });
  params.totals &&
    (data.totals = { items: params.totals, type: 'list', multiple: true });
  params.hasOwnProperty('treeView') &&
    (data.treeView = {
      value: params.treeView,
      items: params.treeView,
      type: 'checkbox',
    });
  params.fields && (data.fields = { items: params.fields, type: 'columns' });
  params.statuses &&
    (data.statuses = {
      items: formatValue(params.statuses.values),
      type: 'list',
      multiple: true,
    });
  params.indicators &&
    (data.indicators = {
      items: params.indicators,
      type: 'list',
      multiple: true,
    });
  params.signatures &&
    (data.signatures = {
      items: params.signatures,
      type: 'list',
      multiple: true,
    });
  params.basePlans &&
    (data.basePlans = {
      items: formatValue(params.basePlans),
      type: 'list',
      multiple: true,
    });
  params.planTypes &&
    (data.planTypes = {
      items: formatValue(params.planTypes),
      type: 'list',
      multiple: false,
    });

  return formattedParamsData(data);
};

export const formatQueryFilters = (params, query) => {
  if (params.filters && params.filters.selectedItems) {
    return {
      ...params,
      filters: {
        ...params.filters,
        selectedItems: params.filters.selectedItems.map(item => {
          let currentItem = item;
          if (item.values && Array.isArray(item.values)) {
            const queryFilter = query.filters.find(
              queryItem =>
                [queryItem.instance, queryItem.field].join('.') ===
                item.fieldId,
            );
            queryFilter !== undefined &&
              queryFilter.values &&
              (currentItem.values = Array.isArray(queryFilter.values)
                ? queryFilter.values
                : Array(queryFilter.values));
          }

          return currentItem;
        }),
      },
    };
  } else {
    return params;
  }
};
export const paramsToQuery = (params, query = null) => {
  const formattedParams = Array.isArray(params)
    ? params
    : Object.entries(params);
  return formattedParams.reduce((acc, [key, value]) => {
    const specialParams = [
      'sorts',
      'fields',
      'filters',
      'statuses',
      'treeView',
      'basePlans',
    ];
    if (!value.selectedItems || value.selectedItems.length === 0) {
      acc[key] = undefined;
    } else {
      if (specialParams.includes(key)) {
        if (key === 'statuses') {
          acc[key] = value.selectedItems.map(item => item.fieldId).join('||');
        }
        if (key === 'sorts') {
          acc[key] = value.selectedItems
            .map(item => `${item.fieldId};${item.direction}`)
            .join('$$');
        }
        if (key === 'fields') {
          acc[key] = value.selectedItems.selectedFields
            .map(item => item.fieldId)
            .join('$$');
        }
        if (key === 'treeView') {
          acc[key] = value.selectedItems;
        }
        if (key === 'filters') {
          if (value.selectedItems.filter(item => item.values).length > 0) {
            acc[key] = value.selectedItems
              .filter(item => item.values)
              .map(item => {
                let operation = item.operation;
                let value = item.values;
                if (Array.isArray(item.values)) {
                  let values = item.values;
                  if (item.values.length === 0 && query) {
                    const queryFilter = query.filters.find(
                      queryItem =>
                        [queryItem.instance, queryItem.field].join('.') ===
                        item.fieldId,
                    );
                    queryFilter !== undefined &&
                      queryFilter.values &&
                      (values = Array.isArray(queryFilter.values)
                        ? queryFilter.values
                        : Array(queryFilter.values));
                  }
                  value = values
                    .map(el => {
                      let value = el;
                      el.valueId && (value = el.valueId);
                      item.fieldType === 'date' &&
                        (value = dayjs(el).format('YYYY-MM-DD'));

                      return value;
                    })
                    .join(item.fieldType === 'date' ? ';' : '||');
                } else {
                  item.fieldType === 'date' &&
                    (value = dayjs(value).format('YYYY-MM-DD'));
                }
                if (
                  filterDateValues.has(item.operation) &&
                  item.fieldType === 'date' &&
                  item.operation !== 'btw'
                ) {
                  operation = filterDateValues.get(item.operation).operator;
                  value = filterDateValues.get(item.operation).dateString;
                }
                let queryString = `${item.fieldId};${operation};${value}`;
                ['null', 'all'].includes(item.operation) &&
                  (queryString = `${item.fieldId};${item.operation}`);
                item.operation === 'btw' &&
                  ['float', 'int'].includes(item.fieldType) &&
                  (queryString = `${item.fieldId};${item.operation};${value.split('||')[0]};${value.split('||')[1]}`);
                return queryString;
              })
              .join('$$');
          } else {
            acc[key] = undefined;
          }
        }
        if (key === 'basePlans') {
          if (
            value.selectedItems[0].values &&
            value.selectedItems[0].values.length > 0
          ) {
            acc[key] = value.selectedItems[0].values.join('||');
          } else {
            acc[key] = undefined;
          }
        }
      } else {
        acc[key] = Array.isArray(value.selectedItems)
          ? value.selectedItems.map(item => item.fieldId).join('$$')
          : value.selectedItems.fieldId;
      }
    }
    return acc;
  }, {});
};

export const queryToParams = (query, params) => {
  return Object.entries(query)
    .filter(([key, value]) => params.hasOwnProperty(key))
    .reduce((acc, [key, value]) => {
      if (value !== undefined) {
        const splitString = value.split(key === 'statuses' ? '||' : '$$');
        let items;
        if (key === 'treeView') {
          items = value.toString();
        } else {
          items = splitString.reduce((acc, item) => {
            const currentItem = params[key].items.find(
              el => el.fieldId === item,
            );
            return [...acc, currentItem];
          }, []);
        }
        acc[key] = { ...params[key], selectedItems: items };
        if (key === 'fields') {
          const fields = params[key].items.reduce(
            (acc, item) => {
              const currentItem = splitString.find(el => el === item.fieldId);
              if (currentItem !== undefined) {
                acc.selectedFields = [
                  ...acc.selectedFields,
                  { ...item, position: splitString.indexOf(currentItem) },
                ];
              } else {
                acc.availableFields = [...acc.availableFields, item];
              }
              acc.selectedFields.length > 0 &&
                acc.selectedFields.sort((a, b) => a.position - b.position);
              return acc;
            },
            { selectedFields: [], availableFields: [] },
          );
          acc[key] = { ...params[key], selectedItems: fields };
        }
        if (key === 'filters') {
          const items = splitString.reduce((acc, item) => {
            const splitItem = item.split(';');
            const currentItem = params[key].items.find(
              el => el.fieldId === splitItem[0],
            );
            if (splitItem.length === 2) {
              currentItem.operation = splitItem[1];
              currentItem.values = splitItem[1];
            }
            if (splitItem.length === 3) {
              const [filterId, filterOperation, filterValue] = item.split(';');
              currentItem.operation = filterOperation;
              currentItem.values = filterValue.split('||');
              if (currentItem.fieldType === 'date') {
                if (filterDateValues.has(filterValue.toLowerCase())) {
                  currentItem.operation = filterValue.toLowerCase();
                  currentItem.values = filterDateValues.get(
                    filterValue.toLowerCase(),
                  ).value;
                } else {
                  currentItem.values = dayjs(currentItem.values);
                }
              }
              if (['boolean', 'bool'].includes(currentItem.fieldType)) {
                currentItem.values = currentItem.values[0];
              }
            }
            if (splitItem.length === 4) {
              const [
                filterId,
                filterOperation,
                filterValueFrom,
                filterValueTo,
              ] = item.split(';');
              currentItem.operation = filterOperation;
              currentItem.values = [filterValueFrom, filterValueTo];
              if (currentItem.fieldType === 'date') {
                currentItem.values = currentItem.values.map(item =>
                  dayjs(item),
                );
              }
            }
            //let value = filterValue;
            //Array.isArray(filterValue) && (value = filterValue.split('||'));
            return [...acc, currentItem];
          }, []);
          acc[key] = { ...params[key], selectedItems: items };
        }
        if (key === 'sorts' && splitString[0].length > 0) {
          const items = splitString.reduce((acc, item) => {
            const [sortField, sortDirection] = item.split(';');
            const currentItem = params[key].items.find(
              el => el.fieldId === sortField,
            );
            //let value = filterValue;
            //Array.isArray(filterValue) && (value = filterValue.split('||'));
            currentItem.direction = sortDirection;
            return [...acc, currentItem];
          }, []);
          acc[key] = { ...params[key], selectedItems: items };
        }
        if (key === 'statuses') {
          acc[key] = { ...params[key], selectedItems: items };
        }
        if (key === 'treeView') {
          acc[key] = { ...params[key], selectedItems: items };
        }
      } else {
        acc[key] = params[key];
      }
      return acc;
    }, {});
};
export const queryToParamsGant = (query, params) => {
  const queryParams = Object.entries(query).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      const splitString = value.split(key === 'basePlans' ? '||' : '$$');
      if (key === 'filters') {
        const items = splitString.reduce((acc, item) => {
          const splitItem = item.split(';');
          const currentItem = params[key].items.find(
            el => el.fieldId === splitItem[0],
          );
          if (splitItem.length === 2) {
            currentItem.operation = splitItem[1];
            currentItem.values = splitItem[1];
          }
          if (splitItem.length === 3) {
            const [filterId, filterOperation, filterValue] = item.split(';');
            currentItem.operation = filterOperation;
            currentItem.values = filterValue.split('||');
            if (currentItem.fieldType === 'date') {
              if (filterDateValues.has(filterValue.toLowerCase())) {
                currentItem.operation = filterValue.toLowerCase();
                currentItem.values = filterDateValues.get(
                  filterValue.toLowerCase(),
                ).value;
              } else {
                currentItem.values = dayjs(currentItem.values);
              }
            }
            if (['boolean', 'bool'].includes(currentItem.fieldType)) {
              currentItem.values = currentItem.values[0];
            }
          }
          if (splitItem.length === 4) {
            const [filterId, filterOperation, filterValueFrom, filterValueTo] =
              item.split(';');
            currentItem.operation = filterOperation;
            currentItem.values = [filterValueFrom, filterValueTo];
            if (currentItem.fieldType === 'date') {
              currentItem.values = currentItem.values.map(item => dayjs(item));
            }
          }
          return [...acc, currentItem];
        }, []);
        acc[key] = { ...params[key], selectedItems: items };
      }
      if (key === 'basePlans') {
        const currentItem = params.filters.items.find(
          el => el.fieldId === 'gantt.base_plan',
        );
        acc.filters = {
          ...params.filters,
          selectedItems: [
            ...acc.filters.selectedItems.filter(
              item => item.fieldType !== 'base_plan',
            ),
            { ...currentItem, values: splitString },
          ],
        };
      }
    } else {
      acc[key] = params[key];
    }
    return acc;
  }, {});
  return { ...params, filters: queryParams.filters };
};
export const formatQueryToSave = (queryData, params, type) => {
  let query;
  const selectedParams = Object.entries(params).filter(
    ([key, value]) => value.selectedItems,
  );
  query = selectedParams.reduce((acc, [key, value]) => {
    let selectedItems = value.selectedItems;
    key === 'fields' && (selectedItems = value.selectedItems.selectedFields);
    if (Array.isArray(selectedItems)) {
      acc[key] = selectedItems.map((item, index) => {
        let value = {
          instance: item.instance,
          field: item.field,
        };
        if (key === 'filters') {
          let filterValue = item.values;
          item.fieldType === 'date' &&
            item.operation === 'btw' &&
            (filterValue = item.values.map(item => item.format('YYYY-MM-DD')));
          Array.isArray(item.values) &&
            (filterValue = item.values.map(item =>
              item.valueId ? item.valueId : item,
            ));
          item.operation && (value.operation = item.operation);
          filterValue && (value.values = filterValue);
          !filterValue && (value.operation = 'all');
          if (item.operation === 'btw' && item.fieldType === 'date') {
            value.min = filterValue[0].format('YYYY-MM-DD');
            value.max = filterValue[1].format('YYYY-MM-DD');
            delete value.values;
          }
          if (
            filterDateValues.has(item.operation) &&
            item.operation !== 'btw'
          ) {
            value.operation = filterDateValues.get(item.operation).operator;
            value.predefined = {
              type: filterDateValues.get(item.operation).dateString,
            };
            delete value.values;
          }
        }
        key === 'sorts' && (value.direction = item.direction);
        key === 'fields' && (value.position = index);

        return value;
      });
      if (key === 'statuses') {
        acc[key] = {
          instance: 'issue',
          field: 'issue_status',
          values: selectedItems.map(item => item.valueId),
          operation: 'eq',
        };
      }
    } else {
      acc[key] =
        key === 'treeView'
          ? selectedItems
          : {
              instance: selectedItems.instance,
              field: selectedItems.field,
            };
    }

    return acc;
  }, {});
  !query.filters && (query.filters = []);
  !query.totals && (query.totals = []);
  !query.sorts && (query.sorts = []);
  !query.indicators && (query.indicators = []);
  query.groups &&
    Array.isArray(query.groups) &&
    (query.group = query.groups[0]);
  query.groups && !Array.isArray(query.groups) && (query.group = query.groups);
  delete query.groups;
  return {
    type: type,
    name: queryData.name,
    query: query,
    accessLevel: queryData.accessLevel,
    roles: queryData.roles,
    projectLevel: queryData.projectLevel,
    projectId: queryData.projectId,
  };
};
